import PropTypes from 'prop-types';
import styled from 'styled-components';

const DividerWithText = styled.hr`
  background-color: ${props => `${props.backgroundColor}`};
  border: 0;
  color: ${props => `${props.color}`};
  margin: 0;
  position: relative;
  text-align: center;
  width: 100%;

  &::before {
    background-color: ${props => `${props.color}`};
    content: '';
    height: 1px;
    left: 0;
    position: absolute;
    top: 50%;
    width: 100%;
  }

  &::after {
    background-color: inherit;
    content: ${props => `'${props.text}'`};
    font-style: italic;
    line-height: 1.5;
    padding: 0 0.5em;
    position: relative;
  }
`;

DividerWithText.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string,
};

DividerWithText.defaultProps = {
  text: '',
};

export default DividerWithText;



// WEBPACK FOOTER //
// ./src/modules/common/DividerWithText.js